import {useEffect} from 'react';
import styles from './.module.css';

const Ads: React.FC = () => {
  const initListener = () => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  };
  useEffect(initListener, []);
  return (
    <div className={styles.ads}>
      <ins
        className='adsbygoogle'
        style={{display: 'block'}}
        data-ad-client='ca-pub-9594185518335769'
        data-ad-slot='5724546843'
        data-ad-format='auto'
        data-full-width-responsive='true'
      ></ins>
    </div>
  );
};

export default Ads;
